import { getAvailableTourDateRange } from 'common/tourHelpers';

import { SR_API_ACTION_GET_AVAILABLE_TOUR_DATES } from 'api/actionTypes';

export default async function getAvailableTourDates({ state, apiClient }) {
  const marketId = state.get(['markets', 'currentUserMarket', 'id']);
  const { startDate, endDate } = getAvailableTourDateRange();

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_AVAILABLE_TOUR_DATES,
    state: state,
    payload: {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      marketId,
    },
    onSuccess({ availableTourDates }) {
      state.set(['availableTourDates'], availableTourDates);
    },
  });
}
